<template>
  <div class="l-body">
    <Top/>
    <div class="wrap kf_bg">
      <div class="kf-wrap zheng">
        <div class="kf_sousuo">
          <div class="jilu">
            <div>
              <el-select  style="line-height:32px;height:32px" v-model="choose">
                <el-option v-for="data in objData" :label="data.game" :value="data.id" :key="data.id" @click.native="handleChange">{{data.game}}</el-option>
              </el-select>
            </div>
          </div>
          <div class="sousuo">
            <div class="search">
              <el-input type="text" placeholder="输入你想搜索的问题的关键词 可同时输入多个关键词，中间使用空格隔开"  v-model="word" style="width:324px;float: left;font-size:12px" />
            </div>
            <div  v-show="faqData.data&&faqData.data.length&&show5"  class="chufasousuo" >
                <i class="el-message-box__close el-icon-close clonse" @click="closeshow5"></i>
              <div class="wt">
                <li v-for="faq in faqData.data"  @click="question(faq.id,faq.answer,faq.question)" :key="faq.id"><a>{{faq.question}}</a></li>
                <el-dialog v-for=" data in questionData" :append-to-body="true"
                  :key="data.id"
                  :visible.sync="dialogVisible"
                  width="30%">
                  <span slot="title" style="color:#ff0000;">塔人问答</span>
				  <span>问题：{{data.title}}</span><br>
				  <br></br>
				  <span>答：</span><br>
                  <span v-html="data.content"></span>
                  <span slot="footer" class="dialog-footer">
                  <img src="/static/assets/wrong.jpg" @click="question1(data.id)"/>
				  <a href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf"><img src="/static/assets/service.jpg" /></a>
                  </span>
                </el-dialog>
              </div>
              <div class="pagei">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
              </div>
          </div>
        </div>
      </div>
	  <!-- <div class="sp tcs1" v-show="show">
		<div class="spinner bs01">
			<i id="colose" @click="theshow"></i>
	  		<div class="tc_zhengwen">
	  			<iframe src="http://mu.zhaouc.com/kf/index.html" frameborder="0"></iframe>
	            <a id="coloses"@click="theshow"><img src="/static/assets/ok.png"></a>
	  		</div>
	    </div>
	  </div> -->
      <div class="kf-jl-box_ls" >
        <div class="kf-wrap zheng">
          <h1>请选择您参与的游戏</h1>
          <h2>GAME SELECTION</h2>
          <div class="game_list">
            <div class="fl mod_guide qtab_container">
              <div class="qtab_nav fl clearfix">
                <li class="left_nav_1" @click="change(0)" :class="role=='role0'?'current':''"><a>全部游戏</a></li>
                <li class="left_nav_2" @click="change(1)" :class="role=='role1'?'current':''"><a>客户端游戏</a></li>
                <li class="left_nav_3" @click="change(2)" :class="role=='role2'?'current':''"><a>网页游戏</a></li>
				<li class="left_nav_4" @click="change(3)" :class="role=='role3'?'current':''"><a>手游游戏</a></li>
              </div>

              <div class="qtab_wrapper fl" >
                <div class="qtab_slide fl" style="display: block">
                  <div>
                    <li v-for="data in data1" @click='ifVipGame(data.id,data.game)' :key="data.id"><img :src="getImgUrl(data.game)"/><span>{{data.game}}</span></li>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h1>新闻公告</h1>
          <h2>NEWS UPDATE</h2>
          <div class="kf_index_news fl">
            <li v-for="data in newData" :style="{backgroundImage: 'url('+ bg(data.picture) +')' }" :key="data.picture">
              <h1><a @click="$router.push({path:'/news', query:{id:data.id}})">{{data.title}}</a></h1>
              <p class="wenzi" style="word-break : break-all">{{data.introduce}}</p>
              <p><span><a @click='$router.push({path:"/newslist"})'>+查看更多</a></span><i>{{data.time}}</i></p>
            </li>
          </div>
          <div class="kf_index_lianjie fl">
            <a href='http://yht.zhaouc.net/'>塔人一号通</a> | <a href="http://vip.zhaouc.com/">塔人贵宾中心</a> | <a href="http://www.tarenwang.com">塔人网络官网</a> | <a href='http://pay.tarenwang.com/'>游戏充值</a> | <a href='http://www.zhaouc.com/taren/jzjh/'>家长监护</a> | <a href='http://my.zhaouc.com/apps/index.php/home/index/userinfo'>防沉迷</a>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Top from '@/components/top.vue'
  export default {
    name: 'Home',
	components: {
	  Top
	},
    data () {
      return {
        choose:1,
        total:0,
        word:'',
        objData:[],
        newData:[],
        faqData:[],
		role:'role0',
        // role0: true,
        // role1: false,
        // role2: false,
        show5:false,
        type:"all",
        dialogVisible: false,
        questionData:[],
        page:1,
        //show:true
      }
    },
    computed: {
      data1(){
        if(this.type=='all'){
          return this.objData;
        }else{
          return this.objData.filter((v)=>{
            return v.type ==this.type;
          });
        }
      },
    },
    created() {
      this.getGameName();
      this.getNews()
    },
    watch: {
      word () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.page=1
          this.shou()
        }, 500)
      },
    },
    methods:{
      bg(img){
        return "http://kf.zhaouc.com"+img.replace("\\","\/")
      },
      getfaq(){
        this.show5=true
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/top',
          params: {
            game_id:this.choose,
            page:this.page
          }
        }).then(res => {
          if(res.data.status==200){
            this.faqData=res.data
            this.total = res.data.count
          }else{
            this.faqData=[]
            this.total = 0
          }
        })
      },
      change(num) {
		if(num==0){
			this.role = 'rolle0'
			this.type='all'
		}else if(num==1){
			this.role = 'role1';
			this.type='1'
		}else if(num==2){
			this.role = 'role2';
			this.type='2'
		}else{
			this.role = 'role3';
			this.type='3'
		}
      },
      question(theid,meg,meg1){
        this.dialogVisible=true
        this.questionData=[]
        this.questionData .push({
          "title" : meg1,
          "content" : meg,
          "id" : theid,
        });
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/addcount',
          params: {
            id:theid,
          }
        })
      },
      question1(id){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/haserror',
          params: {
            id:id,
          }
        })
		this.dialogVisible=false
		this.$alert('已经提交给客服！', {
			confirmButtonText: '确定',
		});
      },
      shou(){
          this.show5=true
          this.$axios({
            method: 'get',
            url: '/index.php/user/User/input',
            params: {
              game_id:this.choose,
              keyword:this.word,
              page:this.page
            }
          }).then(res => {
            if(res.data.status==200){
              this.faqData=res.data
              this.total = res.data.count
            }else if(res.data.status==500){
              this.faqData=[]
              this.total = 0
			  this.$confirm('很抱歉～暂时未找到与您当前问题相关的解答。', {
				confirmButtonText: '确定',
				type: 'warning'
				})
            }
          })
      },
      handleCurrentChange: function(currentPage){
        this.page = currentPage;
		if(this.word.length==0){
			this.getfaq()
		}else{
			this.shou()
		}
      },
      handleChange(){
		this.word=''
        this.page=1
        this.getfaq()
        this.show5=true;
      },
      getGameName() {
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/index'
        }).then(res => {
          if(res.data.status==200){
          this.objData=res.data.data
          }
        })
      },
      getNews() {
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/topnews'
        }).then(res => {
          if(res.data.status==200) {
            this.newData = res.data.data
          }
        })
      },
      ifVipGame(gid,gname){
        if(gid==1||gid==4||gid==5){
          this.$axios({
            method: 'get',
            url: '/index.php/user/User/yzlogin'
          }).then(res => {
            if(res.data.status==500) {
              this.$alert('此账号仅可提交奇迹MU VIP区的问题', {
              	confirmButtonText: '确定',
              });
            }else{
              this.$router.push({path:"/serve",query:{id:gid,name:gname}})
            }
          })
        }else{
          this.$router.push({path:"/serve",query:{id:gid,name:gname}})
        }
      },
      getImgUrl(icon){
        return ("/static/assets/"+icon+".jpg");
      },
      closeshow5(){
        this.show5=false
      },
	 //  theshow(){
		// this.show=false
	 //  }
    }
  }
</script>
<style scoped>
  .clonse{position: absolute;right:5px;top:5px;z-index: 999999;cursor:pointer}
</style>



// WEBPACK FOOTER //
// src/views/home.vue